module.exports = __webpack_public_path__ + "img/skiped-vertical-bar-icon-21022022.203ced73.svg";